import { Form, Link, NavLink } from "react-router";

const SidebarNav = ({
  isLoggedIn,
  notifications,
  toggleNotificationsPanel,
}: {
  isLoggedIn: boolean;
  notifications: boolean;
  toggleNotificationsPanel: () => void;
}) => {
  return (
    <aside className="hidden bg-[#fff] dark:bg-bg-dark lg:block w-[17.375rem] fixed h-screen z-50 p-16 uppercase font-bold text-sm">
      <NavLink to="/">
        <img src="/assets/logo.png" alt="logo" className="h-[4rem]" />
      </NavLink>
      <ul className="flex flex-col text-grey-night dark:text-grey-dark gap-y-2 mt-8">
        <li>
          <NavLink
            to="/"
            prefetch="intent"
            className={({ isActive }) =>
              isActive ? "text-jiwe-red dark:text-[#fff]" : undefined
            }
          >
            Home
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/tournaments"
            prefetch="intent"
            className={({ isActive }) =>
              isActive ? "text-jiwe-red dark:text-[#fff]" : undefined
            }
          >
            Tournaments
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/hubs"
            prefetch="intent"
            className={({ isActive }) =>
              isActive ? "text-jiwe-red dark:text-[#fff]" : undefined
            }
          >
            Hubs
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/games"
            prefetch="intent"
            className={({ isActive }) =>
              isActive ? "text-jiwe-red dark:text-[#fff]" : undefined
            }
          >
            Games
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/about"
            prefetch="intent"
            className={({ isActive }) =>
              isActive ? "text-jiwe-red dark:text-[#fff]" : undefined
            }
          >
            About Us
          </NavLink>
        </li>
        {/* <li>
          <NavLink
            to="/stats"
            prefetch="intent"
            className={({ isActive }) =>
              isActive ? "text-jiwe-red dark:text-[#fff]" : undefined
            }
          >
            Stats
          </NavLink>
        </li> */}
        {/* <li>
          <NavLink to="/results">Results & Standings</NavLink>
        </li>
        */}
        {/* <li>
          <NavLink to="/live-events">Live Events</NavLink>
        </li> */}
      </ul>
      <div className="w-12 mt-4 border-t-[.5px] border-t-divider dark:border-t-divider-dark" />
      <div className="mt-4 text-grey-dark dark:text-grey-darker">
        <NavLink
          to="/profile"
          className={({ isActive }) =>
            isActive
              ? "text-jiwe-red flex gap-x-2 items-center fill-jiwe-red"
              : "flex gap-x-2 items-center fill-grey-dark dark:fill-grey-darker"
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
          >
            <path
              id="Icon_awesome-user-circle"
              data-name="Icon awesome-user-circle"
              d="M6,.563a6,6,0,1,0,6,6A6,6,0,0,0,6,.563ZM6,2.885A2.129,2.129,0,1,1,3.871,5.014,2.129,2.129,0,0,1,6,2.885Zm0,8.323a4.636,4.636,0,0,1-3.544-1.65A2.7,2.7,0,0,1,4.839,8.111a.592.592,0,0,1,.172.027A3.2,3.2,0,0,0,6,8.3a3.191,3.191,0,0,0,.99-.167.592.592,0,0,1,.172-.027A2.7,2.7,0,0,1,9.544,9.558,4.636,4.636,0,0,1,6,11.208Z"
              transform="translate(0 -0.563)"
            />
          </svg>
          <span>Profile</span>
        </NavLink>
        {isLoggedIn && (
          <button
            className="border-0 p-0 m-0 mt-4 bg-[transparent] relative"
            id="view-notifications"
            type="button"
            onClick={() => toggleNotificationsPanel()}
          >
            {notifications && (
              <span className="absolute top-0 right-0 w-2 h-2 bg-jiwe-alt-yellow rounded-full" />
            )}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="size-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5"
              />
            </svg>
            <span className="uppercase font-bold text-sm ml-3 absolute top-[-1px]">
              Notifications
            </span>
          </button>
        )}
      </div>
      <div className="fixed bottom-40 uppercase font-bold text-xs text-grey-dark dark:text-grey-darker">
        {isLoggedIn ? (
          <Form action="/logout" method="post">
            <button
              type="submit"
              className="flex items-center uppercase gap-x-1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="size-6 text-grey-dark dark:text-grey-darker"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"
                />
              </svg>
              <span>Logout</span>
            </button>
          </Form>
        ) : (
          <Link to="/login" className="flex items-center gap-x-1">
            <span className="text-jiwe-orange">Login</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-6 text-jiwe-orange"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25"
              />
            </svg>
          </Link>
        )}
      </div>
      <div className="fixed bottom-12">
        <div className="w-12 mb-4 border-t-[.5px] border-t-divider dark:border-t-divider-dark" />
        <ul className="flex flex-col text-grey-night dark:text-grey-dark gap-y-1 mb-2 !font-noto-sans-cond !text-xs font-bold">
          <li>
            <NavLink
              to="/privacy-policy"
              prefetch="intent"
              className={({ isActive }) =>
                isActive ? "text-jiwe-red dark:text-[#fff]" : undefined
              }
            >
              Privacy Policy
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/terms-and-conditions"
              prefetch="intent"
              className={({ isActive }) =>
                isActive ? "text-jiwe-red dark:text-[#fff]" : undefined
              }
            >
              Terms & Conditions
            </NavLink>
          </li>
        </ul>
        <span className="normal-case font-normal font-noto-sans-cond text-grey-dark dark:text-grey-darker text-xs">
          esports@jiwe.io
        </span>
      </div>
    </aside>
  );
};

export default SidebarNav;
